import React, { useCallback, useEffect, useState } from "react";
import styles from "../renewal/Renew.module.css";
import Navbar from "../../components/ui/Navbar";
import Footer from "../../components/ui/Footer";
// import { useNavigate } from "react-router";
import Menu from "../../components/ui/Menu";
import FixedAgent from "../../utils/api/FixedAgent";
import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import modalStyle from "../customers/Customers.module.css";
import copy from "copy-to-clipboard";

function FixedAgentPins(props) {
  const [modalOpen, setModalOpen] = useState(false);
  const [products, setProducts] = useState([]);
  const [exportOption, setExportOption] = useState("");
  // const [productData, setProductData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [fundAgentModal, setFundAgentModal] = useState(false);
  const [amount, setAmount] = useState(0);
  const [count, setCount] = useState();
  const [fixedAgentEmail, setFixedAgentEmail] = useState();
  const [pinPlatform, setPinPlatform] = useState("");
  const [productType, setProductType] = useState("IEI");
  const [filteredProducts, setFilteredProducts] = useState(products);
  const [exportContent, setExportContent] = useState(null);
  const [type, setType] = useState("");

  const token = useSelector((state) => state.userData.loginData.token);

  //   const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);
      const sellPinRes = await FixedAgent.sellPin({
        token,
        count: amount,
        fixedagent_email: fixedAgentEmail,
        export_option: exportOption,
        // pin_type: productData.platform,
        type: type,
      });
      setIsLoading(false);
      toast.success(sellPinRes?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      fecthPinsCallback();
      setModalOpen(false);
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
    }
  };

  const fecthPinsCallback = useCallback(() => {
    const fetchCartHistory = async () => {
      try {
        setIsLoading(true);
        const productsListRes = await FixedAgent.getPinList({
          token,
        });
        setProducts(productsListRes.data.data);
        setIsLoading(false);
      } catch (err) {
        setIsLoading(false);
        toast.error(err?.response?.data?.message, {
          position: "top-left",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    };
    fetchCartHistory();
  }, [token]);

  useEffect(() => {
    const filterProducts = () => {
      const filteredProducts = products.filter((product) =>
        product?.platform?.toLowerCase().includes(productType.toLowerCase())
      );
      setFilteredProducts(filteredProducts);
    };

    if (productType) {
      filterProducts();
    }
  }, [productType, products]);

  useEffect(() => {
    fecthPinsCallback();
  }, [fecthPinsCallback]);

  // const getProductData = (data) => {
  //   setProductData(data);
  // };

  const exportPinModalOpen = (data) => {
    setPinPlatform(data);
    setFundAgentModal(true);
  };

  const exportPin = async () => {
    setIsLoading(true);
    try {
      const response = await FixedAgent.newExportPins({
        token,
        count: parseInt(count),
        pinType: pinPlatform,
        type,
      });

      const pinCodes = response.data
        .split("\n")
        .slice(1)
        .map((row) => row.split(",")[1]);
      copy(pinCodes.join("\n"));
      toast.success("Copied to clipboard!", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setExportContent(pinCodes.join("\n"));

      // const blob = new Blob([response.data], { type: "text/csv" });
      // const url = URL.createObjectURL(blob);
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = `export_${pinPlatform}_${Date.now()}.csv`;
      // a.setAttribute("allow-downloads", "");
      // document.body.appendChild(a);
      // a.click();
      // document.body.removeChild(a);
      // URL.revokeObjectURL(url);
      toast.success("Pins exported successfully", {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setIsLoading(false);

      setCount("");
    } catch (error) {
      setIsLoading(false);

      toast.error(error.response.data.message, {
        position: "top-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      console.error("Failed to export pins", error);
    }
  };

  const share = () => {
    const isMobile = () =>
      /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);

    if (isMobile() && navigator.share) {
      navigator
        .share({
          text: exportContent,
        })
        .then(() => {
          setFundAgentModal(false);
          setExportContent(null);

          console.log("Successful share");
        })
        .catch((error) => console.log("Error sharing", error));
    } else {
      console.log("Web Share API not supported.");
    }
  };

  return (
    <div>
      <ToastContainer />
      {fundAgentModal && (
        <div
          className={modalStyle.modal_overlay}
          onClick={() => setFundAgentModal(false)}
        >
          <div
            className={modalStyle.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className={modalStyle.modal_title}>Export Pin</h1>
            <div>
              <input
                className={modalStyle.modal_input}
                type="num"
                onChange={(e) => setCount(e.target.value)}
                value={count}
                placeholder="How many do you want to export"
              />

              <select
                className={modalStyle.modal_input}
                value={type}
                onChange={(e) => setType(e.target.value)}
              >
                <option value="">Select Type</option>
                <option value="Commercial">Commercial</option>
                <option value="PrivateMotor">Private Motor</option>
                <option value="TriCycle">Tri Cycle</option>
                <option value="MotorCycle">Motor Cycle</option>
                <option value="Truck">Truck</option>
              </select>

              {!exportContent ? (
                <button
                  disabled={isLoading}
                  className={modalStyle.modal_button}
                  onClick={() => exportPin()}
                >
                  {isLoading ? `Loading...` : `Export`}
                </button>
              ) : (
                <button
                  className={modalStyle.modal_button2}
                  onClick={() => share()}
                >
                  {isLoading ? `Loading...` : `Share Now`}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {modalOpen && (
        <div
          className={styles.modal_overlay}
          onClick={() => setModalOpen(false)}
        >
          <div
            className={styles.modal_card}
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className={styles.modal_title}>
              {/* {productsDetails?.product_name} */}
            </h1>
            {/* <p className={styles.modal_description}>Pin Type </p>
            <select
              className={styles.modal_input}
              value={pinType}
              onChange={(e) => setPinType(e.target.value)}
            >
              <option value="">Select Pin Type</option>
              <option value="IEI">IEI</option>
              <option value="CEI">CEI</option>
            </select> */}
            <p className={styles.modal_description}>Fixed Agent</p>
            <input
              className={styles.modal_input}
              type="text"
              value={fixedAgentEmail}
              onChange={(e) => setFixedAgentEmail(e.target.value)}
              placeholder="Enter Fixed Agent Email"
            />
            <p className={styles.modal_description}>Amount </p>
            <input
              className={styles.modal_input}
              type="num"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter amount"
            />
            <p className={styles.modal_description}>Export Option</p>
            <select
              className={styles.modal_input}
              value={exportOption}
              onChange={(e) => setExportOption(e.target.value)}
            >
              <option value="">Select Export Option</option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </select>

            <p className={styles.modal_description}>Type</p>
            <select
              className={styles.modal_input}
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="">Select Export Option</option>
              <option value="Commercial">Commercial</option>
              <option value="PrivateMotor">Private Motor</option>
              <option value="TriCycle">Tri Cycle</option>
              <option value="MotorCycle">Motor Cycle</option>
              <option value="Truck">Truck</option>
            </select>

            <button
              className={styles.modal_button}
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {isLoading ? "Loading..." : "Proceed"}
            </button>
          </div>
        </div>
      )}

      <div className="menu" onClick={() => props.setShowMenu(false)}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>

      <Navbar title="Pin" setShowMenu={props.setShowMenu} />
      <div>
        <div className={styles.body}>
          <div className={styles.body_bottom}>
            <div
              style={{
                backgroundColor: "#fff3cd",
                color: "#856404",
                border: "1px solid #ffeeba",
                borderRadius: "4px",
                padding: "12px 16px",
                marginBottom: "16px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontWeight: "500",
                fontSize: "15px",
              }}
            >
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "18px",
                  marginRight: "8px",
                }}
                aria-label="Warning"
                role="img"
              >
                ⚠️
              </span>
              Note: CEI pins are currently unavailable.
            </div>
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <p>Pin Type</p>
              <select
                style={{
                  padding: "10px",
                  borderRadius: "25px",
                  border: "1px solid #ccc",
                  width: "100px",
                  outline: "none",
                  "-webkit-appearance": "none",
                  backgroundColor: "white",
                }}
                className={styles.select_option}
                onChange={(e) => setProductType(e.target.value)}
                value={productType}
              >
                {/* <option value="CEI">CEI</option> */}
                <option value="IEI">IEI</option>

                <option value="NICON">NICON</option>
              </select>
            </div>
            <div className={styles.cards_wrapper}>
              {filteredProducts
                ?.filter((product) => product.status === "ACTIVE")
                ?.slice(0, 1)
                ?.map((product, index) => (
                  <div className={styles.card} key={product?.id}>
                    <h1 className={styles.card_title}>{product?.pin}</h1>
                    <p className={styles.card_description}>
                      {product?.platform} -{" "}
                      <span
                        onClick={() => exportPinModalOpen(product?.platform)}
                        style={{
                          fontWeight: "bold",
                          textDecoration: "underline",
                          color: "blue",
                          cursor: "pointer",
                        }}
                      >
                        Export Pins
                      </span>
                    </p>
                    <span className={styles.card_amount}>
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "commercial" &&
                            product.export_option.toLowerCase() === "yes"
                        )?.length
                      }{" "}
                      export,{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "commercial" &&
                            product.export_option.toLowerCase() === "no"
                        )?.length
                      }{" "}
                      non-export Commercial Pin
                      {filteredProducts?.filter(
                        (product) =>
                          product.status === "ACTIVE" &&
                          product.type.toLowerCase() === "commercial" &&
                          product.export_option.toLowerCase() === "yes"
                      )?.length > 1
                        ? "s"
                        : ""}{" "}
                      |{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "privatemotor" &&
                            product.export_option.toLowerCase() === "yes"
                        )?.length
                      }{" "}
                      export,{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "privatemotor" &&
                            product.export_option.toLowerCase() === "no"
                        )?.length
                      }{" "}
                      non-export Private Motor Pin
                      {filteredProducts?.filter(
                        (product) =>
                          product.status === "ACTIVE" &&
                          product.type.toLowerCase() === "privatemotor" &&
                          product.export_option.toLowerCase() === "yes"
                      )?.length > 1
                        ? "s"
                        : ""}{" "}
                      |{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.export_option.toLowerCase() === "yes" &&
                            product.type.toLowerCase() === "tricycle"
                        )?.length
                      }{" "}
                      export,{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "tricycle" &&
                            product.export_option.toLowerCase() === "no"
                        )?.length
                      }{" "}
                      non-export Tri Cycle Pin
                      {filteredProducts?.filter(
                        (product) =>
                          product.status === "ACTIVE" &&
                          product.export_option.toLowerCase() === "yes" &&
                          product.type.toLowerCase() === "tricycle"
                      )?.length > 1
                        ? "s"
                        : ""}{" "}
                      |{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.export_option.toLowerCase() === "yes" &&
                            product.type.toLowerCase() === "motorcycle"
                        )?.length
                      }{" "}
                      export,{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "motorcycle" &&
                            product.export_option.toLowerCase() === "no"
                        )?.length
                      }{" "}
                      non-export Motor Cycle Pin
                      {filteredProducts?.filter(
                        (product) =>
                          product.status === "ACTIVE" &&
                          product.export_option.toLowerCase() === "yes" &&
                          product.type.toLowerCase() === "motorcycle"
                      )?.length > 1
                        ? "s"
                        : ""}{" "}
                      |{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.export_option.toLowerCase() === "yes" &&
                            product.type.toLowerCase() === "truck"
                        )?.length
                      }{" "}
                      export,{" "}
                      {
                        filteredProducts?.filter(
                          (product) =>
                            product.status === "ACTIVE" &&
                            product.type.toLowerCase() === "truck" &&
                            product.export_option.toLowerCase() === "no"
                        )?.length
                      }{" "}
                      non-export Truck Pin
                      {filteredProducts?.filter(
                        (product) =>
                          product.status === "ACTIVE" &&
                          product.export_option.toLowerCase() === "yes" &&
                          product.type.toLowerCase() === "truck"
                      )?.length > 1
                        ? "s"
                        : ""}
                    </span>

                    <span className={styles.card_amount}>
                      {
                        filteredProducts?.filter(
                          (product) => product.status === "EXPORTED"
                        )?.length
                      }{" "}
                      Exported Pin
                      {filteredProducts?.filter(
                        (product) => product.status === "EXPORTED"
                      )?.length > 1
                        ? "s"
                        : ""}
                    </span>

                    {/* <button
                      className={styles.card_button}
                      onClick={() => {
                        setModalOpen(true);
                        getProductData(product);
                      }}
                    >
                      Sell Pin
                    </button> */}
                  </div>
                ))}

              {isLoading &&
                [...Array(3)].map((_, index) => (
                  <div key={index}>
                    <div className={`${styles.card} ${styles.skeleton}`}></div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default FixedAgentPins;
